<mat-expansion-panel #matExpansionPanel>
  <mat-expansion-panel-header data-cy="verifications-header">
    <mat-panel-title>
      <div class="title">Verification Visits</div>
      @if (matExpansionPanel.expanded && !isReadAdmin) {
        <a
          (click)="showAddNew($event)"
          class="fc-link"
          data-cy="new-visit">
          Add New
        </a>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-divider></mat-divider>
  @if (showAddNewForm) {
    <div class="form-container">
      <form [formGroup]="addNewForm" class="verification-form">
        <fc-datepicker formControlName="date" formFieldClass="w-100-1" inputID="date" label="Date"></fc-datepicker>
        <mat-form-field class="w-50-2">
          <mat-label>Type</mat-label>
          <mat-select formControlName="verificationType">
            <mat-option value="Field Verification">Field Verification</mat-option>
            <mat-option value="Desktop Verification">Desktop Verification</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <div class="form-buttons">
        <button (click)="showAddNewForm = false" color="primary" mat-stroked-button>Cancel</button>
        <button (click)="submitNewVisit()" color="primary" mat-raised-button>Save</button>
      </div>
    </div>
  }

  @for (visit of visits; track visit; let i = $index) {
    <div>
      <div [class.hide]="updateVisitIndex === i" class="verification-visit">
        <div class="info">
          <div class="date">{{ visit.date | date: 'longDate' }}</div>
          <div class="type">
            Type:
            <span class="data">{{ visit.verificationType }}</span>
          </div>
        </div>
        <div class="buttons">
          @if (!isReadAdmin) {
            <fa-icon
              (click)="showUpdateForm(i)"
              [icon]="['far', 'pencil']"
              class="blue pencil-icon"></fa-icon>
          }
          @if (!isReadAdmin) {
            <fa-icon
              (click)="deleteVisit(visit.id)"
              [icon]="['far', 'xmark']"
              class="blue close-icon"></fa-icon>
          }
        </div>
      </div>
      @if (updateVisitIndex === i) {
        <div class="form-container">
          <form [formGroup]="updateForm" class="verification-form">
            <fc-datepicker formControlName="date" formFieldClass="w-100-1" inputID="date" label="Date"></fc-datepicker>
            <mat-form-field class="w-50-2">
              <mat-label>Type</mat-label>
              <mat-select formControlName="verificationType">
                <mat-option value="Field Verification">Field Verification</mat-option>
                <mat-option value="Desktop Verification">Desktop Verification</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
          <div class="form-buttons">
            <button (click)="updateVisitIndex = undefined" color="primary" mat-stroked-button>Cancel</button>
            <button (click)="updateVisit()" class="save-button" color="primary" mat-raised-button>Save</button>
          </div>
        </div>
      }
    </div>
  }
</mat-expansion-panel>

@if (showUpdateToast) {
  <div class="toast update">
    <fa-icon [icon]="['fas', 'check-circle']" class="white"></fa-icon>
    Verification Visit Updated
  </div>
}

@if (showDeleteToast) {
  <div class="toast delete">
    <fa-icon [icon]="['fas', 'circle-xmark']" class="red"></fa-icon>
    Verification Visit Deleted
  </div>
}
